require('./cookie-access.less');

jQuery(function () {
    const container = document.querySelector('.cookie-access');
    if(container){
        if (document.cookie.indexOf("cookie-access") != -1) {
            container.classList.remove('cookie-access--active');
        }else{
            container.classList.add('cookie-access--active');
            setTimeout(function (){
                $('#retailcrm-consultant-app').addClass('retailcrm-consultant-app--position-150');
            },1000);

        }
        const apply = container.querySelectorAll('.js-agree');
        apply.forEach(button => {
            button.addEventListener('click', () => {
                container.classList.remove('cookie-access--active');
                $('#retailcrm-consultant-app').addClass('retailcrm-consultant-app--position-0');
                $('#retailcrm-consultant-app').removeClass('retailcrm-consultant-app--position-150');
                document.cookie = 'cookie-access=true; max-age=2592000; path=/';
                return false;
            });
        });
    }
});



// WEBPACK FOOTER //
// ./modules/cookie-access/cookie-access.js